import { render, staticRenderFns } from "./RouteReference.vue?vue&type=template&id=128b7690"
import script from "./RouteReference.vue?vue&type=script&lang=js"
export * from "./RouteReference.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports